// Packages
import Vue from 'vue';

// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/cases/index.scss';

// Blocks
import initRequestForm from '~scripts/blocks/request-form';

// Components
import '~scripts/components/modals';

//
// HEADER
//
import Header from '~scripts/blocks/header';

Header();

//
// NAVIGATION
//
import Navigation from '~scripts/blocks/navigation';

Navigation();

//
// FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

import Cases from './components/Cases.vue';

new Vue({
  el: '#casesApp',
  name: 'casesApp',
  components: {
    Cases,
  },
});
